

/*
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
 
    async onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);

  if (!this.form) {
    formData.append('id', this.querySelector('[name=id]').value);
  }

  const variantId = formData.get('id');

  // ===== QTY LIMIT LOGIC =====
  const productCollections = window.__LIMIT_QTY_COLLECTIONS__ || [];
  const limitCollections = [
    'indagini-su-persone',
    'indagini-su-aziende',
    'indagini-estero'
  ];

  const shouldLimit = productCollections.some(c =>
    limitCollections.includes(c)
  );
    console.group('🧪 QTY LIMIT');
    console.log('📦 Product collections:', productCollections);
    console.log('🚫 Limit collections:', limitCollections);
    console.log('❓ Should limit:', shouldLimit);
    console.log('🆔 Variant ID:', variantId);

  if (shouldLimit) {

     console.log('➕ NEW VARIANT → cart/add');
    console.log('🔢 Quantity forced to 1');
    
    try {
      const cartData = await fetch('/cart.js').then(r => r.json());
      const existingItem = cartData.items.find(
        item => item.variant_id == variantId
      );

      // 👉 SE ESISTE GIÀ → cart/change e STOP
      if (existingItem && this.cart) {

        console.warn('🔁 VARIANT ALREADY IN CART');
        console.log('➡️ Action: cart/change');
        console.log('🔒 Forced quantity = 1');

        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: existingItem.key,
            quantity: 1,
            sections: this.cart.getSectionsToRender().map(s => s.id),
            sections_url: window.location.pathname
          })
        }).then(r => r.json());

        this.cart.renderContents(response);

        // cleanup UI
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      }

      // 👉 SE NON ESISTE → forza quantity = 1
      formData.set('quantity', 1);
    } catch (e) {
      console.error('Qty limit error', e);
    }
  }

  // ===== END QTY LIMIT =====

  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map(section => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then(response => response.json())
    .then(response => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: variantId,
          errors: response.description,
          message: response.message
        });
        this.handleErrorMessage(response.description);
        this.error = true;
        return;
      }

      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!this.error) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantId
        });
      }

      this.error = false;

      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              this.cart.renderContents(response);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        this.cart.renderContents(response);
      }
    })
    .catch(console.error)
    .finally(() => {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
}


    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}  
*/

 /* NUOVO CODICE CON FIX ERROR PRECEDENTE */

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        const idEl = this.form.querySelector('[name=id]');
        if (idEl) idEl.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      } else {
        const idEl = this.querySelector('[name=id]');
        if (idEl) idEl.disabled = false;
        const btn = this.querySelector('button[type=submit]') || this.querySelector('[type="submit"]');
        if (btn) btn.addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]') || this.querySelector('button[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.hideErrors = this.dataset.hideErrors === 'true';

      // guard anti doppio submit (aiuta anche contro 429)
      this._submitting = false;

      // cache firme in memoria per bloccare duplicati senza /cart.js
      // FIX refresh: persistiamo in sessionStorage (solo tab, no localStorage)
      this._sigKey = 'fv_cart_sigs_v1';

      this._getSigs = () => {
        try {
          const raw = sessionStorage.getItem(this._sigKey);
          const arr = raw ? JSON.parse(raw) : [];
          return Array.isArray(arr) ? new Set(arr) : new Set();
        } catch (e) {
          return new Set();
        }
      };

      this._setSigs = (set) => {
        try {
          sessionStorage.setItem(this._sigKey, JSON.stringify(Array.from(set)));
        } catch (e) {}
      };

      this._hasSig = (sig) => {
        const s = this._getSigs();
        return s.has(sig);
      };

      this._addSig = (sig) => {
        const s = this._getSigs();
        s.add(sig);
        this._setSigs(s);
        // mirror in memoria (utile solo per debug)
        window.__FV_SIGS__ = new Set(s);
      };

      // init mirror in memoria da sessionStorage (così dopo refresh resta)
      window.__FV_SIGS__ = window.__FV_SIGS__ || this._getSigs();
    }

    _norm(v) {
      return String(v || '').trim().replace(/\s+/g, ' ').toLowerCase();
    }

    _sig(variantId, name, cfpi) {
      return `${String(variantId)}|${this._norm(name)}|${this._norm(cfpi)}`;
    }

    _cleanup() {
      if (this.submitButton) {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
      }
      const spinner = this.querySelector('.loading-overlay__spinner');
      spinner?.classList.add('hidden');
      this._submitting = false;
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.submitButton) return;
      if (this._submitting) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this._submitting = true;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      spinner?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formEl = this.form || this.querySelector('form');
      const formData = formEl ? new FormData(formEl) : new FormData();

      // garantisce id sempre
      if (!formData.get('id')) {
        const idEl = this.querySelector('[name=id]');
        if (idEl?.value) formData.set('id', idEl.value);
      }

      const variantId = formData.get('id');

      // ===== QTY LIMIT + DUPLICATI su variante + 2 input (NO /cart.js) =====
      const productCollections = window.__LIMIT_QTY_COLLECTIONS__ || [];
      const limitCollections = ['indagini-su-persone', 'indagini-su-aziende', 'indagini-estero'];
      const shouldLimit = productCollections.some(c => limitCollections.includes(c));

      console.group('🧪 QTY LIMIT');
      console.log('📦 Product collections:', productCollections);
      console.log('🚫 Limit collections:', limitCollections);
      console.log('❓ Should limit:', shouldLimit);
      console.log('🆔 Variant ID:', variantId);
      console.groupEnd();

      // Nomi esatti dei tuoi input
      const P1 = 'Nome / Ragione Sociale';
      const P2 = 'Partita IVA / Codice Fiscale del Debitore';

      let pendingSig = null;

      if (shouldLimit) {
        const nameVal = formData.get(`properties[${P1}]`);
        const cfpiVal = formData.get(`properties[${P2}]`);

        const nName = this._norm(nameVal);
        const nCfpi = this._norm(cfpiVal);

        // obbligatori
        if (!nName || !nCfpi) {
          this.handleErrorMessage('Compila Nome / Ragione Sociale e Partita IVA / Codice Fiscale del Debitore.');
          this._cleanup();
          return;
        }

        pendingSig = this._sig(variantId, nName, nCfpi);

        // blocca SOLO se stessa variante + stessi input
       if (this._hasSig(pendingSig)) {

          this.handleErrorMessage('Hai già inserito questa richiesta nel carrello.');
          this._cleanup();
          return;
        }

        // quantity forzata a 1
        formData.set('quantity', 1);
      }
      // ===== END =====

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map(section => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      // ✅ forza add.js per evitare HTML
      const addUrl =
        (window.routes?.cart_add_url && String(window.routes.cart_add_url).endsWith('.js'))
          ? window.routes.cart_add_url
          : (routes?.cart_add_url && String(routes.cart_add_url).endsWith('.js'))
            ? routes.cart_add_url
            : '/cart/add.js';

      fetch(addUrl, config)
        .then(async (res) => {
          const text = await res.text();
          let json;
          try {
            json = JSON.parse(text);
          } catch (e) {
            console.error('cart/add non-JSON. First chars:', text.slice(0, 120));
            throw new Error('cart/add non-JSON');
          }
          if (!res.ok) throw new Error(`Add failed HTTP ${res.status}`);
          return json;
        })
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: variantId,
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          }

          // ✅ add riuscito: memorizza firma
         if (pendingSig) this._addSig(pendingSig);


          // reset form solo su successo
          try {
            this.form?.reset();
          } catch (e) {}

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: variantId
            });
          }

          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((err) => {
          console.error(err);
          this.handleErrorMessage('Errore durante l’aggiunta al carrello. Riprova.');
          this.error = true;
        })
        .finally(() => {
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }
          spinner?.classList.add('hidden');
          this._submitting = false;
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage =
        this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
